// frontend/src/api/apiFunction/usageServices.js
import { USAGE_URL } from '../restEndpoint';
import { httpPost, httpGet, httpGetBlob } from '../../utils/httpMethods';

export const getUsageByRole = async (role) => {
    try {
        const response = await httpPost({
            url: `${USAGE_URL}/total-tokens`,
            payload: { role },
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getUsageByAll = async () => {
    try {
        const response = await httpGet({
            url: `${USAGE_URL}/usage-by-all`,
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getUsageByUserId = async (userId) => {
    try {
        const response = await httpGet({
            url: `${USAGE_URL}/get-usage-by-userid/${userId}`,
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getUsageByOrganizationId = async (orgId) => {
    try {
        const response = await httpGet({
            url: `${USAGE_URL}/get-usage-by-organization/${orgId}`,
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getHotModels = async () => {
    try {
        const response = await httpGet({
            url: `${USAGE_URL}/hot-model`,
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const downloadInvoicePdf = async (userId) => {
    try {
        const response = await httpGetBlob({
            url: `${USAGE_URL}/generate-pdf/${userId}`
        });
        return response;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const sendInvoiceEmail = async (userId) => {
    try {
        const response = await httpGet({
            url: `${USAGE_URL}/send-invoice-email/${userId}`,
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};